import 'reflect-metadata';
import React from 'react';
import { createRoot } from 'react-dom/client';
import { HashRouter } from 'react-router-dom';
import { registry } from '@betgames/bg-state-manager';
import { ErrorBoundary } from 'components/ErrorBoundary';
import { ROOT_CLASS } from 'constants/constants';
import { Root } from 'routes/Root';
import { app } from 'store/App';
import { envConfig } from 'constants/envConfig';
import 'twain-sport-fe-mono/styles/main.global.scss';
import './styles/main.global.scss';
import './polyfills';

registry.configureDevtools({
    enabled: envConfig.isLocalEnv || envConfig.isStagingEnv,
});

app.store.configure(window.location.hash);

const App: React.FC = () => (
    <React.StrictMode>
        <HashRouter>
            <ErrorBoundary>
                <Root />
            </ErrorBoundary>
        </HashRouter>
    </React.StrictMode>
);

const container = document.querySelector(`.${ROOT_CLASS}`);
const root = createRoot(container);

root.render(<App />);
